import {useParams} from 'react-router-dom';

import {serverAPI} from 'features/server/api/serverAPI';
import {SERVER_METRICS_POLLING_INTERVAL} from 'features/server/lib/serverMetrics';
import {getServerBackgroundKind} from 'features/server/lib/serverView';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import {isTranslate} from 'shared/lib/lang';

export const useServerDetails = () => {
    const {serverId} = useParams<{serverId: string}>();
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint === 'small' || breakpoint === 'mini';

    const {data: server, isLoading} = serverAPI.useGetServerQuery(serverId ?? '', {
        skip: !serverId,
        pollingInterval: SERVER_METRICS_POLLING_INTERVAL,
    });

    const backgroundKind = server ? getServerBackgroundKind(server.status, isTranslate()) : null;

    return {server, isLoading, isMobile, backgroundKind};
};
